import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUserId } from '@/utils/auth';
import BreadCrumb from '@/components/Breadcrumb';
import MessageNotice from '@/components/MessageAgentSub/MessageNotice';
import MyTask from '@/components/MessageAgentSub/MyTask.vue';
import { getVirtualGroupAccessReal, refreshMessage, refreshTodo } from '@/api/message';
export default {
  components: {
    MyTask: MyTask,
    MessageNotice: MessageNotice,
    BreadCrumb: BreadCrumb
  },
  data: function data() {
    return {
      activeName: 'task',
      switchType: '卡片切换',
      systemModuleArr: [],
      systemModuleMap: {},
      taskMesage: ''
    };
  },
  watch: {
    '$route.query.type': function $routeQueryType(newVal) {
      this.activeName = newVal;
    },
    immediate: true
  },
  created: function created() {
    this.activeName = this.$route.query.type || 'task';
    // await Promise.all([this.getMenuData(), this.getSystemInnerData(), this.getSystemModule()])
    this.getMenuData();
    // this.getSystemInnerData()
    this.getSystemModule();
  },
  methods: {
    // 获取系统模块数据
    getSystemModule: function getSystemModule() {
      var _this = this;
      getVirtualGroupAccessReal({
        codes: ['SYSTEM_MOUDLE'],
        systemId: 3
      }).then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this.systemModuleArr = result;
          // 将后台返回的系统模块数据组装成对象
          var arr = [];
          _this.systemModuleArr.forEach(function (_ref) {
            var detailList = _ref.detailList;
            return detailList.forEach(function (item) {
              return arr.push(item);
            });
          });
          // eslint-disable-next-line no-return-assign,no-sequences
          _this.systemModuleMap = arr.reduce(function (map, _ref2) {
            var dictName = _ref2.dictName,
              dictCode = _ref2.dictCode;
            return map[dictName] = dictCode, map;
          }, {});
        }
      });
    },
    switchTypeClick: function switchTypeClick() {
      this.switchType = this.switchType === '列表切换' ? '卡片切换' : '列表切换';
    },
    tabClickFn: function tabClickFn(e) {
      var type = e.name;
      if (type === 'task') {
        this.$refs.MyTask.searchForm();
        this.refreshTodoFn();
        this.$store.dispatch('settings/changeSetting', {
          key: 'breadcrumb',
          value: {
            resourcePath: '消息中心/任务中心'
          }
        });
      } else {
        this.$refs.MessageNotice.searchForm();
        this.refreshMessageFn();
        this.$store.dispatch('settings/changeSetting', {
          key: 'breadcrumb',
          value: {
            resourcePath: '消息中心/消息通知'
          }
        });
      }
      this.$router.push({
        query: {
          type: type
        }
      });
    },
    refreshMessageFn: function refreshMessageFn() {
      var _this2 = this;
      refreshMessage().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this2.setMessage(result);
        }
      });
    },
    refreshTodoFn: function refreshTodoFn() {
      var _this3 = this;
      refreshTodo().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this3.setTodo(result);
        }
      });
    },
    // 设置未读消息数
    setMessage: function setMessage(message) {
      localStorage.setItem('MESSAGE_UPDATE_EVENT', message);
      this.$store.dispatch('message/setMessage', message);
    },
    //
    setTodo: function setTodo(todo) {
      localStorage.setItem('TODO_UPDATE_EVENT', todo);
      this.$store.dispatch('message/setTodo', todo);
    },
    changTaskCount: function changTaskCount(data) {
      this.taskMesage = data;
    },
    // 获取系统名称数据
    // getSystemInnerData () {
    //   getSystemInnerList().then(res => {
    //     const { code, result } = res
    //     if (code === '200') {
    //       const systemNameArr = result.records.map(({ systemName, systemId }) => ({ label: systemName, value: systemId }))
    //       localStorage.setItem('SYSTEM_NAME_ARR', JSON.stringify(systemNameArr))
    //     }
    //   })
    // },
    getMenuData: function getMenuData() {
      var _this4 = this;
      this.$API.getMenuInfo({
        userId: getUserId()
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this4.$store.dispatch('settings/changeSetting', {
            key: 'menuArr',
            value: res.result.resourceList
          });
        }
      }).catch(function () {});
    }
  }
};